import { useAppDispatch } from "./useReduxHooks";
import { userApi, accountsApi, campaignsApi } from "../api";
import { resetAuth } from "../features/authSlice";

export const useLogout = () => {
  const dispatch = useAppDispatch();

  return () => {
    localStorage.clear();
    dispatch(userApi.util.resetApiState());
    dispatch(accountsApi.util.resetApiState());
    dispatch(campaignsApi.util.resetApiState());
    dispatch(resetAuth());
  };
};
